interface ListProps {
  rows?: number;
  ariaLabel?: string;
}

// Серия серых animate-pulse-плейсхолдеров — заменяет «Загрузка…»-строку
// в списках. ariaLabel описывает что грузится для скрин-ридера.
export function SkeletonList({ rows = 3, ariaLabel }: ListProps) {
  return (
    <div aria-label={ariaLabel} role="status" className="flex flex-col gap-2">
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          aria-hidden="true"
          className="h-16 animate-pulse rounded-md border border-slate-200 bg-slate-50"
        />
      ))}
    </div>
  );
}
